import { render, staticRenderFns } from "./EstablishmentPrivileges.vue?vue&type=template&id=fa9b0d82&scoped=true&"
import script from "./EstablishmentPrivileges.vue?vue&type=script&lang=js&"
export * from "./EstablishmentPrivileges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa9b0d82",
  null
  
)

export default component.exports